import { SCREENS, REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = {
  currentScreen: SCREENS.PROGRESS,
  shallFadeIn: false,
  shallFadeOut: false,
  shallAnimateHintIn: false,
  shallAnimateHintOut: false,
  shallAnimateOrb: false,
  shallShowPayoff: false,
  shallAnimateIllustrationIn: false,
  shallAnimateIllustrationOut: false,
};

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        currentScreen: payload,
        shallAnimateHintIn: false,
        shallAnimateHintOut: false,
        shallAnimateOrb: false,
        shallShowPayoff: false,
        shallAnimateIllustrationIn: false,
        shallAnimateIllustrationOut: false,
      };

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM:
      return {
        ...state,
        shallAnimateHintOut: false,
        shallAnimateOrb: false,
      };

    case REDUX_ACTIONS.FADE_IN:
      return {
        ...state,
        shallFadeIn: true,
        shallFadeOut: false,
      };

    case REDUX_ACTIONS.FADE_OUT:
      return {
        ...state,
        shallFadeIn: false,
        shallFadeOut: true,
      };

    case REDUX_ACTIONS.ANIMATE_HINT_IN:
      return {
        ...state,
        shallAnimateHintIn: true,
        shallAnimateHintOut: false,
      };

    case REDUX_ACTIONS.ANIMATE_HINT_OUT:
      return {
        ...state,
        shallAnimateHintIn: false,
        shallAnimateHintOut: true,
      };

    case REDUX_ACTIONS.ANIMATE_ORB:
      return {
        ...state,
        shallAnimateOrb: true,
      };

    case REDUX_ACTIONS.SHOW_PAYOFF:
      return {
        ...state,
        shallShowPayoff: true,
      };

    case REDUX_ACTIONS.ANIMATE_ILLUSTRATION_IN:
      return {
        ...state,
        shallAnimateIllustrationIn: true,
        shallAnimateIllustrationOut: false,
      };

    case REDUX_ACTIONS.ANIMATE_ILLUSTRATION_OUT:
      return {
        ...state,
        shallAnimateIllustrationIn: false,
        shallAnimateIllustrationOut: true,
      };

    default:
      return state;
  }
};

export default screenReducer;
